<template>
  <div class="rap-infiniteloading" ref="scroller" @touchstart="touchStartHandle($event)" @touchmove="touchMoveHandle($event)">
    <slot></slot>
    <div class="load-more">
      <div class="bottom-tips">
        <template v-if="isLoading">
          <i class="loading-hint"></i><span class="loading-txt">加载中...</span>
        </template>
        <span v-else-if="!hasMore" class="tips-txt">{{ unloadMoreTxt }}</span>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len */
export default {
  name: 'rap-infiniteloading',
  props: {
    hasMore: {
      type: Boolean,
      'default': true,
    },
    isLoading: {
      type: Boolean,
      'default': false,
    },
    threshold: {
      type: Number,
      'default': 200,
    },
    useWindow: {
      type: Boolean,
      'default': true,
    },
    useCapture: {
      type: Boolean,
      'default': false,
    },
    isShowMod: {
      type: Boolean,
      'default': false,
    },
    unloadMoreTxt: {
      type: String,
      'default': '哎呀，这里是底部了啦',
    },
    scrollChange: {
      type: Function,
    },
  },
  data() {
    return {
      startX: 0,
      startY: 0,
      diffX: 0,
      diffY: 0,
      beforeScrollTop: 0,
    };
  },

  mounted() {
    const parentElement = this.getParentElement(this.$el);
    let scrollEl = window;
    if (this.useWindow === false) {
      scrollEl = parentElement;
    }
    this.scrollEl = scrollEl;
    this.scrollListener();
  },

  methods: {
    touchStartHandle(e) {
      try {
        this.startX = Number(e.changedTouches[0].pageX);
        this.startY = Number(e.changedTouches[0].pageY);
      } catch (e) {
        // console.log(e.message);
      }
    },
    touchMoveHandle(e) {
      const endX = Number(e.changedTouches[0].pageX);
      const endY = Number(e.changedTouches[0].pageY);
      this.diffX = endX - this.startX;
      this.diffY = endY - this.startY;
    },
    getParentElement(el) {
      return el && el.parentNode;
    },
    scrollListener() {
      this.scrollEl.addEventListener(
        'scroll',
        this.handleScroll,
        this.useCapture
      );
      window.addEventListener('resize', this.handleScroll, this.useCapture);
    },

    requestAniFrame() {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        ((callback) => {
          window.setTimeout(callback, 1000 / 60);
        })
      );
    },

    handleScroll() {
      this.requestAniFrame()(() => {
        if (
          !this.isScrollAtBottom() ||
          !this.hasMore ||
          this.isLoading ||
          !this.isShowMod
        ) {
          return false;
        } else {
          this.$emit('loadmore');
        }
      });
    },

    calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    },

    getWindowScrollTop() {
      return window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollTop;
    },

    isScrollAtBottom() {
      let offsetDistance;

      let resScrollTop = 0;

      const windowScrollTop = this.getWindowScrollTop();

      if (this.useWindow) {
        offsetDistance =
          this.calculateTopPosition(this.$refs.scroller) +
          this.$refs.scroller.offsetHeight -
          windowScrollTop -
          window.innerHeight;
      } else {
        const { scrollHeight, clientHeight, scrollTop } = this.scrollEl;

        offsetDistance = scrollHeight - clientHeight - scrollTop;
        resScrollTop = scrollTop;
      }
      this.$emit(
        'scrollChange',
        this.useWindow ? windowScrollTop : resScrollTop
      );
      // 保证是往下滑动的
      // const beforeScrollTop = this.beforeScrollTop;
      this.beforeScrollTop = windowScrollTop;

      return (
        offsetDistance <= this.threshold &&
        windowScrollTop >= this.beforeScrollTop
      );
    },
  },

  activated() {
    if (this.keepAlive) {
      this.keepAlive = false;
      this.scrollListener();
    }
  },

  deactivated() {
    this.keepAlive = true;
    this.scrollEl.removeEventListener(
      'scroll',
      this.handleScroll,
      this.useCapture
    );
    window.removeEventListener('resize', this.handleScroll, this.useCapture);
  },

  destroyed() {
    this.scrollEl.removeEventListener(
      'scroll',
      this.handleScroll,
      this.useCapture
    );
    window.removeEventListener('resize', this.handleScroll, this.useCapture);
  },
};
</script>
<style scoped lang="less">
.rap-infiniteloading {
  .bottom-tips {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e6e6e6;
    font-size: 12px;
    .loading-txt {
      padding-left: 5px;
    }
    .loading-hint {
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7)
        no-repeat 0 0;
      background-size: 100% 100%;
      animation: rotate 1s infinite;
    }
    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .tips-txt {
      position: relative;
      &:after,
      &:before {
        content: '';
        height: 1px;
        width: 20px;
        background-color: #e6e6e6;
        position: absolute;
        top: 50%;
        margin-top: -0.5px;
      }
      &:before {
        left: -25px;
      }
      &:after {
        right: -25px;
      }
    }
  }
}
</style>
